export const selectUploadItems = (state: RootState) => state.uploads.items;

export const selectUploadItem = (id: string) => (state: RootState) => state.uploads.items[id];
